import script from "./NavbarController.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarController.vue?vue&type=script&setup=true&lang=js"

import "./NavbarController.vue?vue&type=style&index=0&id=5b38122c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b38122c"]])

export default __exports__